export const tabNames: { [key: string]: { [key: string]: string } } = {
  Polish: {
    language: "Polish",
    send: "wyślij",
    tokenWarning: " Przekroczono dzienny limit tokenów",
    limits: "ograniczenia",
    chat: "Otwórz czat",
    placeholder: "zadaj mi pytanie...",
    portfolio: "Portfolio",
    about: "O mnie",
    moreAbout: "wiecej o mnie",
    skills: "Umiejętności",
    courses: "kursy",
    downloadCV: "Pobierz CV",
    answer:
      "Zmień język rozmowy na Polski. Podaj mi więcej informacji o twoim : ",
    interests: "zainteresowania",
    ai: "sztuczna inteligencja",
    tools: "pozostałe narzędzia",
    education: "edukacja",
    frontend: "frontend",
    backend: "backend",
    welcome: "Witaj!",
    welcomeSpeech:
      " Witaj na moim CV. Znajdziesz tutaj trochę informacji o mnie w poszczególnych zakładkach lub po prostu zapytaj o to mojego bota",
    tip: " Potrzebujesz więcej informacji? Zapytaj MateuszBot",
    law: "© 2024 Mateusz Świderski. Wszelkie prawa zastrzeżone",
  },
  UnitedKingdom: {
    language: "UnitedKingdom",
    send: "send",
    tokenWarning: "Daily token limit exceeded",
    limits: "limits",
    chat: "Open Chat",
    placeholder: "ask me a question...",
    portfolio: "Portfolio",
    about: "About me",
    skills: "skills",
    courses: "courses",
    moreAbout: "more about me",
    downloadCV: "Download CV",
    answer:
      "Zmień język rozmowy na angielski. Give me more information about your:  ",
    interests: "intersts",
    ai: "artificial intelligence",
    tools: "other tools",
    education: "education",
    frontend: "frontend",
    backend: "backend",
    welcome: "Hi!",
    welcomeSpeech:
      " Welcome to my CV. Here you will find some information about me in individual tabs or just ask my bot about it",
    tip: "Need more information? Ask MateuszBot",

    law: "© 2024 Mateusz Świderski. All Rights Reserved",
  },
  Deutsch: {
    language: "Deutsch",
    send: "schicken",
    tokenWarning: "Das tägliche Token-Limit wurde überschritten",
    limits: "Einschränkungen",
    chat: "Chat öffnen",
    placeholder: "Stellen Sie mir eine Frage...",
    portfolio: "Portfolio",
    about: "Über mich",
    skills: "Fähigkeiten",
    courses: "Kurse",
    moreAbout: "Mehr über mich",
    downloadCV: "Lebenslauf herunterladen",
    answer:
      "Zmień język rozmowy na niemiecki to ważne. Nie pros o zmianę języka i odpowiadaj po Niemiecku jak najlepiej umiesz. Geben Sie mir weitere Informationen zu Ihrem:  ",
    interests: "Interessen",
    ai: "künstliche Intelligenz",
    tools: "andere Werkzeuge",
    education: "Ausbildung",
    frontend: "frontend",
    backend: "backend",
    welcome: "Hallo!",
    welcomeSpeech:
      "Willkommen in meinem Lebenslauf. Hier findest du in einzelnen Tabs ein paar Informationen über mich oder frag einfach meinen Bot danach",
    tip: "Benötigen Sie weitere Informationen? Fragen Sie MateuszBot",

    law: "© 2024 Mateusz Świderski. Alle Rechte vorbehalten",
  },
};
